var pickupProduct = 0;
var CRdeliveryProductEnabled = false;

stores.forEach(store => {
  for (const key in store) {
    if (typeof store[key] === 'string') {
      // Replace any " with \" to avoid breaking string literals
      //store[key] = store[key].replace(/"/g, '\\"');
      store[key] = store[key].replace(/"/g, '&quot;');
    }
  }
});

// **** Better way to set special products in one place **** ////
var specialProduct1 = false;
var specialProduct2 = false;
var specialProduct3 = false;

for (var i = 0; i < crItems.length; i++ ){
  var itemCollections = crItems[i].collections
  var itemTitle = crItems[i].name;
  if (itemTitle === 'Pickup Instore') continue;
  //console.log({itemTitle})  
  //console.log('-->', itemCollections)
 
 

  if (itemTitle.toLowerCase().indexOf('Gift Card'.toLowerCase()) > -1) {
    specialProduct1 = true;
  } else {
    specialProduct2 = true;
  }
}
// if gift and nongift card are in the cart, remove exclude check
if (specialProduct1 === true && specialProduct2 === true) {
  var skipExcludedCheck = true;
}

  stores.sort(function(a, b){
    if(a.name.toLowerCase()  < b.name.toLowerCase()) { return -1; }
    if(a.name.toLowerCase() > b.name.toLowerCase()) { return 1; }
    return 0;
  })
/*document.addEventListener('crJQActivated', function (e) {
  jqCR('#delivery-date-start').attr('placeholder', 'Choose a date')

  // Set pickup default:
  var isDeliveryClicked = Cookies.get('deliveryClicked');
  //console.log('-------------------------------------------------------------------->', isDeliveryClicked)  
  jqCR('.cr-shipping-method').on('click', function(){
    var inFifteenMinutes = new Date(new Date().getTime() + 15 * 60 * 1000);
    Cookies.set('deliveryClicked', '1', {
        expires: inFifteenMinutes
    });
  })
  
  // Click on the pickup option only if delivery was not clicked earlier
  setTimeout(function(){
    console.log('-------------------------------------------------------------------->', !isDeliveryClicked)  
    if (!isDeliveryClicked){
	    jqCR('.js-toggle-pickup').click()
    }
  }, 900)
})*/

// add an ID to your template container
const template = `
  <div id="cr-delivery-address-block">
    <!-- First & Last Name -->
    <div class="cr-form-row">
      <label id="delivery-name-label" for="delivery-name">Recipient Name</label>
      <div style="display: flex; gap: 10px;">
        <div style="flex: 1;">
          <input
            name="attributes[delivery_first_name]"
            aria-labelledby="delivery-first-name"
            id="delivery-first-name"
            type="text"
            placeholder="First name"
            aria-required="true"
            style="width: 100%; margin-bottom: 0;"
            required
          />
        </div>
        <div style="flex: 1;">
          <input
            name="attributes[delivery_last_name]"
            aria-labelledby="delivery-last-name"
            id="delivery-last-name"
            type="text"
            placeholder="Last name"
            aria-required="true"
            style="width: 100%; margin-bottom: 0;"
            required
          />
        </div>
      </div>
    </div>

    <!-- Street Address -->
    <div class="cr-form-row">
      <label id="delivery-street-address-label" for="delivery-street-address">
        
      </label>
      <input
        name="attributes[delivery_street_address]"
        aria-labelledby="delivery-street-address"
        id="delivery-street-address"
        type="text"
        placeholder="Street address"
        aria-required="true"
        style="width: 100%; margin-bottom: 0;"
        required
      />
    </div>

    <!-- Postal Code -->
    <div class="cr-form-row">
      <label id="delivery-postal-code-label" for="delivery-postal-code">        
      </label>
      <input
        name="attributes[delivery_postal_code]"
        aria-labelledby="delivery-postal-code"
        id="delivery-postal-code"
        type="text"
        placeholder="Postal Code (Optional)"
        aria-required="true"
        style="width: 100%; margin-bottom: 0;"
      />
    </div>

    <!-- City -->
    <div class="cr-form-row">
      <label id="delivery-city-label" for="delivery-city">        
      </label>
      <input
        name="attributes[delivery_city]"
        aria-labelledby="delivery-city"
        id="delivery-city"
        type="text"
        placeholder="City"
        aria-required="true"
        style="width: 100%; margin-bottom: 0;"
        required
      />
    </div>

    <!-- Phone Number -->
    <div class="cr-form-row">
      <label id="delivery-phone-label" for="delivery-phone">        
      </label>
      <input
        name="attributes[delivery_phone]"
        aria-labelledby="delivery-phone"
        id="delivery-phone"
        type="tel"
        placeholder="Phone number (Israeli # preferred)"
        aria-required="true"
        style="width: 100%; margin-bottom: 0;"
        required
      />
    </div>
  </div>
`;

document.addEventListener('crDeliveryActivated', function () {
  // if it's already been inserted, do nothing
  if (document.getElementById('cr-delivery-address-block')) return;

  setTimeout(() => {
    const wrapper = document.querySelector('.cr-delivery-date-wrapper');
    if (wrapper) {
      wrapper.insertAdjacentHTML('afterend', template);
    } else {
      console.warn('Could not find .cr-delivery-date-wrapper in the DOM');
    }
  }, 200);
});
// end custom fields for delivery


// Delivery
var crDeliveryDateCallback = function(picker, blackoutdatesCollection){
  var t = new Date()
  var t = new Date()
  var currentDay = t.getDate();
  var currentMonth = t.getMonth();
  var currentyear = t.getFullYear();
  var weekDay = t.getDay();
  var currentHour = t.getHours()
  
  
  switch (weekDay) {
    case 0:
      picker.set('min', 4);	
      break;
    case 1:
      console.log('Mondays');
  	  picker.set('min', 6);	
      break;
    case 2:
      console.log('Tuesday');
  	  picker.set('min', 6);	
      break;
    case 3:
      console.log('Wednesday');
  	  picker.set('min', 6);	
      break;
    case 4:
      console.log('Thursday');
  	  picker.set('min', 6);	
      break;
    case 5:
      console.log('Friday');
  	  picker.set('min', 5);	
      break;
    case 6:
      console.log('Saturday');
  	  picker.set('min', 4);	
      break;
        
  }
  blackoutdatesCollection.push(6);
  blackoutdatesCollection.push(7);
  picker.set('disable', blackoutdatesCollection);
   
}
// Pickup
var crDateCallback = function(picker, selectedStore, blackoutdatesCollection){
  var t = new Date()
  var t = new Date()
  var currentDay = t.getDate();
  var currentMonth = t.getMonth();
  var currentyear = t.getFullYear();
  var weekDay = t.getDay();
  var currentHour = t.getHours()
  
  
  switch (weekDay) {
    case 0:
      picker.set('min', 4);	
      break;
    case 1:
      console.log('Mondays');
  	  picker.set('min', 6);	
      break;
    case 2:
      console.log('Tuesday');
  	  picker.set('min', 6);	
      break;
    case 3:
      console.log('Wednesday');
  	  picker.set('min', 6);	
      break;
    case 4:
      console.log('Thursday');
  	  picker.set('min', 6);	
      break;
    case 5:
      console.log('Friday');
  	  picker.set('min', 5);	
      break;
    case 6:
      console.log('Saturday');
  	  picker.set('min', 4);	
      break;
        
  }
  blackoutdatesCollection.push(6);
  blackoutdatesCollection.push(7);
  picker.set('disable', blackoutdatesCollection);
   
}
document.addEventListener('crPickupActivated', function (e) {   
  console.log('____ activated _____')
  jqCR('#storeUL').before('<input type="text" name="pickup-store-search" id="pickup-store-search" onkeyup="storePickup.storeFilter()" placeholder="Search school or program..." class="valid" aria-invalid="false">')            
  jQuery('#storeUL a').each(function(){
    var storeId = jQuery(this).data('store-id');
    var zipCode = jQuery(this).data('zip-code');
    var city = jQuery(this).data('city');
    var storeName = jQuery(this).data('name')
    if (typeof storeName !== "undefined") storeName = storeName.replace('z ', '')  
    //console.log(storeName)
    if (storeName === 'OTHER SCHOOLS OR PROGRAMS') {
      var nameSection = jQuery(this).html(storeName);
    }     
  })

});
  document.addEventListener('crDeliveryActivated', function (e) {
  	console.log('delivery activated')
    console.log(CRexcludedFromPickup)
    // If the product is excluded from pickup remove the delivery option as well
    if (CRexcludedFromPickup === true) {
      jqCR('.pickup-wrapper').remove()
      return;
    }
    //jqCR('#delivery-date-start').hide()
    if (specialProduct1 !== true) {
      var tt = setInterval(function(){disableCheckoutButton();}, 1000);
      setTimeout(function() { clearInterval(tt); }, 2000);    
    }
    
    jqCR(document).on('change', '#delivery-date-start', function(){
      setTimeout(function(){
      console.log('check');checkDeliveryFields()
      }, 400)
      
      
    })  
    trackChange(jqCR("#delivery-date-start")[0] );    
  })

/*document.addEventListener('crPickupActivated', function (e) { 
    console.log('____ activated _____');
    if (specialProduct1 !== true) {
      //disableCheckoutButton();
      //var tt = setInterval(function(){disableCheckoutButton();}, 1000);
      //setTimeout(function() { clearInterval(tt); }, 5000);    
    }
    

  jqCR('#pickup-date-start, #note-pickup-date, #pickup-first-name, #pickup-last-name, #pickup-number').on('mouseout keyup change', function(){
  	//console.log('check for others and activate checkout')  	
    checkPickupFields()
  })
  
  //jqCR(document).on('change', '#pickup-selected-store', function(){checkPickupFields()})  
  //trackChange(jqCR("#pickup-selected-store")[0] );  

  jqCR(document).on('change', '#note-pickup-date', function(){checkPickupFields()})  
  trackChange(jqCR("#note-pickup-date")[0] );
});*/


MutationObserver = window.MutationObserver || window.WebKitMutationObserver;

var trackChange = function(element) {
  var observer = new MutationObserver(function(mutations, observer) {
    if(mutations[0].attributeName == "value") {
        jqCR(element).trigger("change");
    }
  });
  observer.observe(element, {
    attributes: true
  });
}

function checkPickupFields(){
  	var pickupDate = jqCR('#pickup-date-start').val();
    var firstName = jqCR('#pickup-first-name').val();
    var lastName = jqCR('#pickup-last-name').val();
    var phone = jqCR('#pickup-number').val();
    var selectedStoreId = jqCR('#pickup-selected-store-id').val()
    if (specialProduct1 === true) {
      activateCheckoutButton();
      return;
    }
    if (selectedStoreId && firstName && lastName) {
    	activateCheckoutButton();
    } else {
    	disableCheckoutButton()
    }
}

function checkDeliveryFields(){
  	var deliveryDate = jqCR('#delivery-date-start').val()
    if (specialProduct1 === true) {
      activateCheckoutButton();
      return;
    }
    if (deliveryDate) {
    	activateCheckoutButton();
    } else {
    	disableCheckoutButton()
    }
}

function activateCheckoutButton(){
    document.querySelector('[name=checkout]').disabled = false;
  }

function disableCheckoutButton(){    
    //document.querySelector('[name=checkout]').disabled = true;
}